// Beta 版面(BetaLayout)網址參數的唯一真相來源。
//
// 這裡管四個參數:view / projectId / ticket / cid。工作項目的 deep-link 參數
// (wi / wino / wisub)由 utils/workItemUrlParams 管,兩邊不互相踩。
//
// 寫入端只有 BetaLayout 的 pushUrl / replaceUrl,而它們一律走 react-router 的
// setSearchParams —— 不要再直接呼叫 window.history.pushState,否則 router 的
// searchParams 會落後於網址列,變成兩個真相來源。

export const VALID_VIEWS = [
  'my-tasks', 'project', 'project-phases', 'global-search',
  'global-ticket-search', 'timeline', 'board', 'milestone', 'calendar',
];

/**
 * 從現有網址出發,只改自己管的四個參數,其餘原樣保留。
 *
 * 不能砍掉重建一份新的 URLSearchParams:?v= 的新舊 UI 切換、工作項目 deep-link 的
 * wi/wino/wisub 都在網址上,一進站的正規化若把它們洗掉,分享出去的連結會當場失效。
 * 要「離開目前工作項目」時由呼叫端負責清(見 clearWorkItemRef),不要在這裡順手刪。
 */
export const buildUrlParams = ({ view, projectId, ticketNo, cid }, search = window.location.search) => {
  const params = new URLSearchParams(search);
  if (view && view !== 'my-tasks') params.set('view', view); else params.delete('view');
  if (projectId) params.set('projectId', String(projectId)); else params.delete('projectId');
  if (ticketNo != null) {
    if (cid) params.set('cid', cid);
    params.set('ticket', String(ticketNo));
  } else {
    params.delete('ticket');
    // cid 是 Ticket 與工作項目共用的公司 scope,還有人用著就不能清
    if (!params.get('wi') && !params.get('wino')) params.delete('cid');
  }
  return params;
};

/** 從網址讀出版面狀態。 */
export const parseUrlParams = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  const view = params.get('view') || 'my-tasks';
  // projects.id 是 BIGSERIAL(number),URL 讀出來是 string,不轉型會讓 === 比對全部失效
  const rawProjectId = params.get('projectId');
  const projectId = rawProjectId && Number.isFinite(Number(rawProjectId)) ? Number(rawProjectId) : null;
  const ticketNo = params.get('ticket') ? Number(params.get('ticket')) : null;
  const cid = params.get('cid') || null;
  return { view: VALID_VIEWS.includes(view) ? view : 'my-tasks', projectId, ticketNo, cid };
};
